<!-- Main Container -->
@if (isConsignmentReady && consignment) {
  <div class="">
    <div class="row">
      <div class="col-md-12">
        <!-- Breadcrumb -->
        @if (items && items.length > 0) {
          <div class="card flex justify-content-center mt-2 mb-2" style="border: none;">
            <p-breadcrumb class="no-border max-w-full" [model]="items" [home]="home"></p-breadcrumb>
          </div>
        }
        <!-- Page Header -->
        <div class="page-header">
          <div class="page-header-content">
            <div class="page-header-text">
              <h1 class="page-title">
                @if (consignmentId) {
                  {{ 'viewConsignmentV2.editConsignment' | transloco }}
                }
                @if (!consignmentId) {
                  {{ 'viewConsignmentV2.addConsignment' | transloco }}
                }
              </h1>
              <p class="page-subtitle">{{ 'viewConsignmentV2.pageSubtitle' | transloco }}</p>
            </div>
            <div class="page-header-actions">
              @if (consignmentId && selectedInventory.length > 0) {
                <button type="button" pButton icon="fa fa-file-pdf-o" [label]="'viewConsignmentV2.downloadDeliveryDocumentation' | transloco"
                  (click)="generatePdf($event)" class="p-button-secondary p-button-outlined">
                </button>
              }
              @if ((authConfig.IsAdministrator || authConfig.IsArtist) && !consignment.IsDispatched) {
                <button type="button" pButton icon="fa fa-save" [label]="'viewConsignmentV2.saveConsignment' | transloco"
                  (click)="saveConsignment($event)" class="p-button-outlined"
                  [disabled]="!consignment.GalleryId || !consignment.Name || selectedInventory.length <= 0">
                </button>
              }
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Dispatched Warning -->
    @if (consignmentId && consignment.IsDispatched) {
      <div class="row g-0 border bg-warning-subtle px-3 py-2 mt-2">
        <div class="col-12 text-center fst-italic">
          {{ 'viewConsignmentV2.alreadyDispatched' | transloco }}
          @if (consignment.Gallery) {
            <span>{{ 'viewConsignmentV2.dispatchedToGallery' | transloco: { businessName: consignment.Gallery.BusinessName, name: consignment.Gallery.Name } }}</span>
            } {{ 'viewConsignmentV2.soItCantBeChanged' | transloco }}
          </div>
        </div>
      }
      <div class="row mt-3 p-2">
        <!-- Consignment Details -->
        @if (consignmentId && consignment.IsDispatched) {
          <div>
            <consignment-data [selectedConsignment]="consignment"></consignment-data>
          </div>
        }
        <!-- Editable Consignment Form -->
        @if (!consignment.IsDispatched) {
          <div class="row mt-2 mb-3 g-0">
            <p-panel [header]="'viewConsignmentV2.consignmentDetails' | transloco" [toggleable]="false">
              <div class="form-horizontal pb-4 p-3" role="form">
                <div class="form-body">
                  <!-- Artist Dropdown (Admin Only) -->
                  @if (authConfig.IsAdministrator && !consignmentId) {
                    <div class="form-group mt-2">
                      <label class="form-label">{{ 'viewConsignmentV2.artist' | transloco }}</label>
                      <p-dropdown [options]="artists" [(ngModel)]="artistId"
                        [disabled]="!!consignmentId || consignment.IsDispatched" [placeholder]="'viewConsignmentV2.selectArtist' | transloco"
                        (onChange)="onArtistChanged($event.value)" [filter]="true" [filterBy]="'label'"
                        [optionLabel]="'label'" [optionValue]="'value'" [style]="{'width':'100%'}"
                        appendTo="body">
                      </p-dropdown>
                    </div>
                  }
                  <!-- Gallery Dropdown -->
                  <div class="form-group mt-2">
                    <label class="form-label"><span class="text-danger">*</span> {{ 'viewConsignmentV2.gallery' | transloco }}</label>
                    <p-dropdown [options]="artistConnectedGalleries" [(ngModel)]="consignment.GalleryId"
                      [disabled]="!!consignmentId || !artistId || consignment.IsDispatched"
                      [placeholder]="!artistId ? ('viewConsignmentV2.selectArtistFirst' | transloco) : ('viewConsignmentV2.selectGallery' | transloco)" [filter]="true"
                      [filterBy]="'label'" [optionLabel]="'label'" [optionValue]="'value'"
                      (onChange)="onGalleryChanged($event)" [style]="{'width':'100%'}"
                      appendTo="body">
                    </p-dropdown>
                  </div>
                  <!-- Consignment Name -->
                  <div class="form-group mt-3">
                    <label class="form-label"><span class="text-danger">*</span> {{ 'viewConsignmentV2.name' | transloco }}</label>
                    <input type="text" class="form-control" [(ngModel)]="consignment.Name"
                      [placeholder]="'viewConsignmentV2.enterName' | transloco" [style]="{'width':'100%'}"
                      [disabled]="consignment.IsDispatched" />
                    </div>
                    <!-- Sale Type Radio Buttons -->
                    <div class="form-group mt-3">
                      <label for="saleType" class="form-label">{{ 'viewConsignmentV2.saleType' | transloco }}</label>
                      <div class="d-flex justify-content-start">
                        <div class="d-flex align-items-center">
                          <p-radioButton name="saleType" value="Consignment"
                            [(ngModel)]="consignment.GallerySaleType" inputId="saleTypeAsConsignment">
                          </p-radioButton>
                          <label for="saleTypeAsConsignment" class="ms-1">{{ 'viewConsignmentV2.consignment' | transloco }}</label>
                        </div>
                        <div class="d-flex align-items-center ms-3">
                          <p-radioButton name="saleType" value="WholeSale"
                            [(ngModel)]="consignment.GallerySaleType" inputId="saleTypeAsWholeSale">
                          </p-radioButton>
                          <label for="saleTypeAsWholeSale" class="ms-1">{{ 'viewConsignmentV2.wholesale' | transloco }}</label>
                        </div>
                      </div>
                    </div>
                    <!-- Commission and Status -->
                    <div class="row mt-3">
                      @if (consignment.GallerySaleType == 'Consignment') {
                        <div class="col-6 form-group">
                          <label class="form-label">{{ 'viewConsignmentV2.commission' | transloco }}</label>
                          <p-dropdown [options]="commissionOptions" [(ngModel)]="consignment.Commission"
                            [disabled]="true" name="Commission" [style]="{'width':'100%'}"
                            appendTo="body">
                          </p-dropdown>
                        </div>
                      }
                      <div class="col-6 form-group">
                        <label class="form-label">{{ 'viewConsignmentV2.status' | transloco }}</label>
                        <p-dropdown [options]="statusItem" [(ngModel)]="consignment.ConsignmentStatus"
                          [disabled]="consignment.IsDispatched" [style]="{'width':'100%'}"
                          appendTo="body">
                        </p-dropdown>
                      </div>
                      <!-- 🔥 New SalesTaxPercentage Input Field -->
                      <div class="form-group mt-2">
                        <label class="form-label">{{ 'viewConsignmentV2.salesTaxPercentage' | transloco }}</label>
                        <input type="number" class="form-control" [(ngModel)]="consignment.SalesTaxPercentage"
                          [disabled]="true" [placeholder]="'viewConsignmentV2.salesTaxPlaceholder' | transloco" [style]="{'width':'100%'}" />
                          @if (selectedGalleryDetails) {
                            <small class="text-muted">
                              {{ 'viewConsignmentV2.fetchedFromGallery' | transloco: { percentage: (selectedGalleryDetails.SalesTaxPercentage ?? 0) } }}
                            </small>
                          }
                        </div>
                      </div>
                    </div>
                  </div>
                </p-panel>
              </div>
            }
            <!-- Artwork Selection Area -->
            <div class="row g-0 mt-3 mb-2">
              <!-- Available Artworks -->
              @if (!consignmentId || !consignment.IsDispatched) {
                <div class="col-9 border px-3 py-3 bg-white shadow-sm ">
                  <div class="d-flex justify-content-between align-items-center mb-2">
                    <div class="fw-bold fs-6">
                      <i class="pi pi-images color-artwork me-1"></i> {{ 'viewConsignmentV2.availableArtworks' | transloco }} -
                      @if (isCurrentInventoryLoaded) {
                        <span>({{ currentInventory.length }})</span>
                      }
                    </div>
                    <!-- Sort icon and label -->
                    <div class="d-flex align-items-center" style="cursor: pointer;" (click)="toggleSort()">
                      <i class="pi pi-sort-alt p-2" style="font-size: 1.2rem; color: #178d9b;" [title]="sortLabel">
                      </i>
                      <span class="ms-1 small" style="color: #ecaf68;">
                        {{ sortLabel }}
                      </span>
                    </div>
                  </div>
                  <div class="text-muted small mb-3">
                    {{ 'viewConsignmentV2.artworksAvailableInInventory' | transloco }}
                    <span class="d-block">{{ 'viewConsignmentV2.clickToSelect' | transloco }}</span>
                    <span class="text-secondary">{{ 'viewConsignmentV2.selectedWillAppear' | transloco }}</span>
                  </div>
                  <!-- Loading State -->
                  @if (!isCurrentInventoryLoaded) {
                    <div class="loading-state">
                      <div class="row mb-2">
                        @for (placeholder of [1,2,3,4,5,6]; track placeholder) {
                          <div class="col-2 mb-3">
                            <div class="skeleton-card">
                              <div class="skeleton-image"></div>
                              <div class="skeleton-text"></div>
                            </div>
                          </div>
                        }
                      </div>
                      <div class="text-center text-muted small mt-2">
                        <i class="pi pi-spin pi-spinner me-2"></i> {{ 'viewConsignmentV2.loadingArtworks' | transloco }}
                      </div>
                    </div>
                  }
                  <!-- Loaded State -->
                  @if (isCurrentInventoryLoaded) {
                    <div class="row mb-2">
                      @for (rowData of currentInventory; track rowData) {
                        <div class="col-2 mb-3">
                          <div class="d-flex flex-column align-items-center rounded-3 shadow-sm bg-light h-100 cursor-pointer product-background border"
                            (click)="selectInventory(rowData)" style="transition: transform 0.2s;"
                            onmouseover="this.style.transform='scale(1.03)';"
                            onmouseout="this.style.transform='scale(1)';" [title]="'viewConsignmentV2.clickToSelectItem' | transloco: { name: rowData.Name }">
                            <!-- Image Container -->
                            <div class="image-container d-flex justify-content-center align-items-center p-1 border-bottom w-100 position-relative">
                              <!-- Circle Info Icon -->
                              <div class="artwork-info-icon"
                                (click)="openProductDialog(rowData.Id); $event.stopPropagation()"
                                [title]="'viewConsignmentV2.viewProductDetails' | transloco">
                                <i class="pi pi-info-circle"></i>
                              </div>
                              <img [src]="rowData.ProductImgUrl ? rowData.ProductImgUrl : 'assets/images/No-Image.png'"
                                (error)="$any($event.target).src='assets/images/No-Image.png'"
                                class="img-fluid rounded; object-fit: contain; w-100" />
                              </div>
                              <!-- Product Name -->
                              <div class="text-center px-2 py-2 w-100">
                                <h3 class="card-title text-uppercase text-truncate small mb-0">
                                  {{ rowData.Name }}
                                </h3>
                              </div>
                            </div>
                          </div>
                        }
                        <!-- No Data Fallback -->
                        @if (currentInventory.length === 0) {
                          <div class="text-muted text-center w-100 py-5">
                            <i class="pi pi-image me-2"></i> {{ 'viewConsignmentV2.noArtworksFound' | transloco }}
                          </div>
                        }
                      </div>
                    }
                  </div>
                }
                <!-- Selected Artworks -->
                @if (!consignmentId || !consignment.IsDispatched) {
                  <div class="col-3 border px-2 bg-light shadow-sm ">
                    <!-- Dispatch Warning -->
                    @if (consignmentId && !consignment.IsDispatched && selectedInventory.length > 0) {
                      <div class="alert alert-warning p-3 rounded mt-2 mb-2"
                        >
                        <div class="d-flex align-items-start mb-2">
                          @if (consignment.Gallery && consignment.Gallery.GalleryImgUrl) {
                            <img [src]="consignment.Gallery.GalleryImgUrl" class="rounded-circle me-2"
                              style="width: 28px; height: 28px; object-fit: cover;" />
                            }
                            <div class="flex-grow-1">
                              <div class="fw-semibold text-dark">
                                {{ 'viewConsignmentV2.dispatchThisConsignmentTo' | transloco }}
                                <span class="text-primary">{{ consignment.Gallery?.BusinessName || ('viewConsignmentV2.selectedGallery' | transloco)
                                }}</span>
                              </div>
                              <div class="small text-muted mt-1">
                                {{ 'viewConsignmentV2.onceDispatchedNoChanges' | transloco }}
                              </div>
                            </div>
                          </div>
                          <button type="button" pButton class="btn btn-danger btn-sm w-100 mt-2" icon="fa fa-truck"
                            [label]="'viewConsignmentV2.dispatchNow' | transloco" (click)="dispatchConsignmentDialog()"
                            [title]="'viewConsignmentV2.dispatchButtonTitle' | transloco">
                          </button>
                        </div>
                      }
                      <div class="fw-bold fs-6 text-center mt-3 mb-2">
                        🧺 {{ 'viewConsignmentV2.selectedArtworks' | transloco }}
                      </div>
                      <div class="d-flex justify-content-center mb-2">
                        @if (selectedInventory.length > 0) {
                          <span
                            class="badge text-white d-inline-flex align-items-center justify-content-center"
                            style="background-color: #178d9b; font-weight: 700; width: 30px; height: 30px; border-radius: 50%;">
                            {{ selectedInventory.length }}
                          </span>
                        }
                      </div>
                      @if (consignmentId && !consignment.IsDispatched && selectedInventory.length > 0) {
                        <div class="text-muted small text-center mb-3"
                          >
                          {{ 'viewConsignmentV2.artworksWillBeIncluded' | transloco }}
                        </div>
                      }
                      <div class="row g-3 mb-2">
                        @for (selected of selectedInventory; track selected) {
                          <div class="col-6">
                            <div class="d-flex flex-column align-items-center rounded-3 shadow bg-light border h-100 cursor-pointer"
                              (click)="moveToCurrentInventory(selected); $event.stopPropagation()"
                              style="transition: transform 0.2s;" onmouseover="this.style.transform='scale(1.03)';"
                              onmouseout="this.style.transform='scale(1)';"
                              [title]="'viewConsignmentV2.clickToRemove' | transloco: { name: selected.Name }">
                              <div class="image-container d-flex justify-content-center align-items-center p-1 border-bottom w-100 position-relative"
                                [title]="'viewConsignmentV2.clickToViewDetails' | transloco: { name: selected.Name }">
                                <!-- Circle Info Icon -->
                                <div class="artwork-info-icon"
                                  (click)="openProductDialog(selected.Id); $event.stopPropagation()"
                                  [title]="'viewConsignmentV2.viewProductDetails' | transloco">
                                  <i class="pi pi-info-circle"></i>
                                </div>
                                <img [src]="selected.ProductImgUrl || 'assets/images/No-Image.png'"
                                  (error)="$any($event.target).src='assets/images/No-Image.png'"
                                  class="img-fluid rounded object-fit: contain; w-100" />
                                </div>
                                <div class="text-center px-2 py-2 w-100">
                                  <div class="text-uppercase fw-semibold text-dark text-truncate small">
                                    {{ selected.Name }}
                                  </div>
                                </div>
                              </div>
                            </div>
                          }
                        </div>
                        @if (selectedInventory.length === 0) {
                          <div class="text-muted text-center py-5">
                            <i class="pi pi-info-circle me-1"></i> {{ 'viewConsignmentV2.noArtworksSelectFromLeft' | transloco }}
                          </div>
                        }
                      </div>
                    }
                  </div>
                </div>
                <!-- Dispatched Artworks View -->
                @if (consignmentId && consignment.IsDispatched) {
                  <div class="col-12 mt-3 mb-3">
                    <p-panel [toggleable]="false" [header]="'viewConsignmentV2.selectedArtworksCount' | transloco: { count: selectedInventory.length }">
                      {{ 'viewConsignmentV2.followingArtworksConsigned' | transloco }}
                      @if (selectedInventory.length > 0) {
                        <div class="row my-2">
                          @for (product of selectedInventory; track product) {
                            <div class="col-4 mt-2">
                              <div class="position-relative">
                                <div class="custom-product-container border cursor-pointer">
                                  <div class="custom-img-container">
                                    <img [src]="product.ProductImgUrl ? product.ProductImgUrl : 'assets/images/No-Image.png'"
                                      (error)="$any($event.target).src='assets/images/No-Image.png'"
                                      class="custom-img rounded-cube border" [alt]="'viewConsignmentV2.productImage' | transloco" style="height: 105px;">
                                    </div>
                                    <div class="d-flex flex-column w-100 p-2 mb-2">
                                      <div class="d-flex flex-row justify-content-between">
                                        <div class="text-uppercase fw-semibold ellipsis">
                                          <a href="javascript:void(0);" class="text-uppercase text-dark fw-semibold"
                                          pTooltip="{{ product.Name }}">{{ product.Name }}</a>
                                        </div>
                                      </div>
                                      <div class="small mt-1">
                                        @if (product.ArtTypeName) {
                                          <div class="d-flex flex-row justify-content-between">
                                            <div class="d-flex align-items-center cursor-pointer">
                                              <div class="fw-semibold text-uppercase">{{ 'viewConsignmentV2.artType' | transloco }} </div>
                                              <div class="ms-1">{{product.ArtTypeName }}</div>
                                            </div>
                                          </div>
                                        }
                                        @if (product.ArtistRevenue) {
                                          <div class="d-flex flex-row justify-content-between">
                                            <div class="d-flex align-items-center cursor-pointer">
                                              <div class="fw-semibold text-uppercase">{{ 'viewConsignmentV2.artistRevenue' | transloco }} </div>
                                              <div class="ms-1">{{product.ArtistRevenue |
                                              currency:'USD':'symbol':'1.2-2'}}</div>
                                            </div>
                                          </div>
                                        }
                                        @if (product.CreatedDate) {
                                          <div class="d-flex flex-row justify-content-between">
                                            <div class="d-flex align-items-center cursor-pointer">
                                              <div class="fw-semibold text-uppercase">{{ 'viewConsignmentV2.created' | transloco }} </div>
                                              <div class="ms-1">{{ product.CreatedDate | date: 'dd/MM/yyyy' }}
                                                @if (isToday(product.CreatedDate)) {
                                                  {{ 'viewConsignmentV2.today' | transloco }}
                                                }
                                                @if (!isToday(product.CreatedDate)) {
                                                  {{ 'viewConsignmentV2.daysAgo' | transloco: { days: dispatchedDaysAgo(product.CreatedDate) } }}
                                                }
                                              </div>
                                            </div>
                                          </div>
                                        }
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            }
                          </div>
                        }
                        @if (selectedInventory.length === 0) {
                          <div class="row my-2">
                            <div class="col">{{ 'viewConsignmentV2.noDataAvailable' | transloco }}</div>
                          </div>
                        }
                      </p-panel>
                    </div>
                  }
                </div>
              }

              <!-- Price Dialog -->
              <p-dialog [(visible)]="isArtistRevenuDailogVisible" [modal]="true" [style]="{ 'width': '530px'}"
                (onHide)="closeDialog()">
                <div class="p-3">
                  <div class="d-flex flex-column">
                    <span><strong class="h5">{{ 'viewConsignmentV2.warningPriceThisItem' | transloco }}</strong></span>
                    <span>{{ 'viewConsignmentV2.artworksMustHavePrice' | transloco }}</span>
                  </div>

                  <div class="row">
                    <div class="px-0 col-md-4">
                      <div class="mb-2 mt-4">
                        @if (selectedProduct) {
                          <img [src]="selectedProduct.ProductImgUrl || 'assets/images/No-Image.png'"
                            (error)="$any($event.target).src='assets/images/No-Image.png'"
                            class="ms-4" height="70">
                        }
                      </div>
                      @if (selectedProduct) {
                        <div class="ms-2 fw-bold">{{selectedProduct.Name}}</div>
                      }
                    </div>
                    <div class="px-0 col-md-4">
                      <div class="ms-2 mt-3">
                        <span class="fw-bold mt-1">{{ 'viewConsignmentV2.artistPrice' | transloco }}</span>
                        @if (selectedProduct) {
                          <input type="number" [disabled]="!isProductAvailable" [(ngModel)]="selectedProduct.ArtistRevenue"
                            min="0" class="form-control mt-1" [placeholder]="'viewConsignmentV2.artistPrice' | transloco"
                            (input)="preventNegativeValues($event)">
                        }
                        <button type="button" class="btn btn-outline-primary mt-2"
                          (click)="openPriceCalculatorDialog($event)">
                          <i class="pi pi-calculator me-1"></i> {{ 'viewConsignmentV2.priceChecker' | transloco }}
                        </button>
                      </div>
                    </div>
                    <div class="px-0 col-md-4">
                      <div class="d-flex justify-content-center align-items-center h-100">
                        <button type="submit" class="btn btn-primary btn-block mb-2 w-75"
                        (click)="updateArtistRevenue(selectedProduct)">{{ 'viewConsignmentV2.addPrice' | transloco }}</button>
                      </div>
                    </div>
                  </div>
                  <div class="d-flex justify-content-between mt-3">
                    <button type="button" class="btn btn-outline-primary"
                    (click)="onEditSelectedProduct(selectedProduct.Id)">{{ 'viewConsignmentV2.editItem' | transloco }}</button>
                    <button type="button" class="btn btn-outline-danger" (click)="closeDialog()">{{ 'viewConsignmentV2.cancel' | transloco }}</button>
                  </div>
                </div>
              </p-dialog>

              <!-- Dispatch Comments Dialog -->
              <p-dialog [header]="'viewConsignmentV2.dispatchComments' | transloco" [(visible)]="showCommentDialog" [modal]="true" [style]="{'width': '430px' }"
                (onHide)="closeDispatchDialog()">
                <form class="form-horizontal mt-2 px-3">
                  <div class="text-muted small">
                    <i class="fa fa-info-circle me-1"></i> {{ 'viewConsignmentV2.dispatchCommentInfo' | transloco }}
                  </div>
                  <div class="form-group my-3">
                    <div class="panel-container">
                      <div class="panel-body">
                        <div class="form-group position-relative">
                          <label for="comments" class="form-label">{{ 'viewConsignmentV2.yourComments' | transloco }}</label>
                          <textarea id="comments" pInputTextarea rows="3" name="comments"
                            [(ngModel)]="formData.ConsignmentDispatchComment"
                            [placeholder]="'viewConsignmentV2.optionalAddComments' | transloco" class="form-control">
                          </textarea>
                          <div class="emoji-icon position-absolute cursor-pointer fs-6" (click)="openEmojiDialog()"
                            style="top: 60%; right: 0.5rem; transform: translateY(-50%);">
                            (😍)
                          </div>
                          <button pButton type="button" class="p-button-danger p-button-outlined w-100 mt-2"
                            [label]="'viewConsignmentV2.dispatchNow' | transloco" (click)="dispatchConsignment($event)">
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </form>
              </p-dialog>

              <!-- Price Calculator Dialog -->
              @if (showPriceCalculatorDialog) {
                <price-calculator-dialog [showDialog]="showPriceCalculatorDialog"
                  (onInjectArtistRevenue)="onInjectArtistRevenue($event)" (onClose)="onPriceCalculatorDialogClose($event)">
                </price-calculator-dialog>
              }

              <!-- Emoji Picker Dialog -->
              @if (displayEmojiDialog) {
                <app-emoji-list [showDialog]="displayEmojiDialog" (onClose)="closeEmojiDialog($event)"
                  (emojiClick)="addEmoji($event)">
                </app-emoji-list>
              }

              @if (showProductDialog) {
                <app-product-details-dialog [showProductDialog]="showProductDialog" [productId]="productId"
                  (onClose)="closeProductDialog()">
                </app-product-details-dialog>
              }


              @if (showTermsAcceptanceDialog) {
                <terms-acceptance-dialog [showDialog]="showTermsAcceptanceDialog" [galleryId]="consignment.GalleryId || ''"
                  (onAccepted)="onTermsAccepted()" (onCancelled)="onTermsCancelled()">
                </terms-acceptance-dialog>
              }